import { render, staticRenderFns } from "./NameBoards.vue?vue&type=template&id=86eb15a4"
import script from "./NameBoards.vue?vue&type=script&lang=js"
export * from "./NameBoards.vue?vue&type=script&lang=js"
import style0 from "./NameBoards.vue?vue&type=style&index=0&id=86eb15a4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports